import { usePostMutation } from "@/api/swr/useMutation";
import { companyUserCreateSchema } from "@/schema/console/companies/CompanyUser";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof companyUserCreateSchema, z.ZodNull>
>[3];

export const useCreateCompanyUser = (config?: Config) => {
  return usePostMutation(
    companyUserCreateSchema,
    z.null(),
    `/console/company_users`,
    config,
  );
};
